import dragula from 'dragula';

window.criarModulos = (response) => {
    $('#modulos').empty();
    var modulos = response.data.modulos;
    if(modulos.length > 0){
        $.each(modulos, function(index, element){
            $('#modulos').append(`
                <div id="modulo-${element.id}" class="border-radius-separator" style="margin-bottom: 12px" >
                    <div class="d-flex justify-content-between align-items-center modulo-card" data-id="${element.id}">
                        <div class="d-flex">
                            <span class="material-symbols-outlined icon-modulos handle"
                                  style="margin:0px 6px 12px 6px ;cursor:pointer">drag_indicator</span>
                            <div class="d-flex flex-column justify-content-center align-items-start" style="user-select: text">
                                <div class="uni-title-medium titulo-modulo mb-1" data-id="${element.id}">${element.nome}</div>
                                <div class="uni-body-small descricao-modulo" data-id="${element.id}">${element.descricao}</div>
                            </div>
                        </div>
                        <div class="d-flex align-items-start justify-content-center h-100 p-2">
                            <span class="material-symbols-outlined icon-modulos editar-modulo" style="cursor: pointer" data-id="${element.id}" data-toggle="modal" data-target="#editar-modulo">edit</span>
                            <span class="material-symbols-outlined icon-modulos excluir-modulo cursor-pointer" style="cursor: pointer" data-id="${element.id}">delete</span>
                            <span class="material-symbols-outlined icon-modulos expandir-aulas" style="cursor: pointer" data-id="${element.id}">expand_more</span>
                        </div>
                    </div>
                    <div class="modulo-aulas d-none flex-column" data-id="${element.id}">
                        <div class="d-flex flex-column mb-3">
                            <span class="uni-body-medium mb-2 text-black">Adicionar</span>
                            <div class="d-flex">
                                <span class="adicionar-aula d-flex align-items-center border-radius-separator uni-label-large tag-item mr-2" data-id="${element.id}" data-toggle="modal" data-target="#adicionar-aula-modal">
                                    <span class="material-symbols-outlined icon-aula mr-2">article</span>
                                    Aula
                                </span>
                                <span class="adicionar-avaliacao d-flex align-items-center border-radius-separator uni-label-large tag-item" data-id="${element.id}" data-toggle="modal" data-target="#adicionar-avaliacao-modal">
                                    <span class="material-symbols-outlined icon-aula mr-2">quiz</span>
                                    Avaliação
                                </span>
                            </div>
                        </div>
                        <div id="aulas-${element.id}" class="d-flex flex-column w-100 h-100">

                        </div>
                    </div>
                </div>`).slideDown('slow');
        });
        $("#img-nada-para-exibir").addClass('d-none');
        $("#img-nada-para-exibir").removeClass('d-flex');
    } else {
        $("#img-nada-para-exibir").removeClass('d-none');
        $("#img-nada-para-exibir").addClass('d-flex');
    }
}

//função para arrastar módulos. Ao dropar salva posições dos módulos
window.dragAndDropModulos = () =>{
    dragula([document.getElementById('modulos')], {
        moves: function(el, container, handle) {
            return handle.className === 'material-symbols-outlined icon-modulos handle';
        },
        revertOnSpill: true
    }).on('drop', function(el, _) {
        mudarPosicaoModulos();
    }.bind(this));
}

window.criarAulas = (response, idModulo) => {
    $('#aulas-'+idModulo).empty();
    var aulas = response.data.aulas;
    if(aulas.length > 0){
        $.each(aulas, function(index, element) {
            let cargaHoraria = element.carga_horaria;
            //formatando carga horaria
            const [hours, minutes] = cargaHoraria.split(':').slice(0, 2);
            cargaHoraria = hours + ':' + minutes;
            let tipo = element.tipo === 'A' ? 'aula' : 'avaliacao';
            let icon = element.tipo === 'A' ? 'article' : 'quiz';
            let pesoTags = '';
            if(element.tipo === 'P') {
                pesoTags = `<span class="tag-nota-minima uni-body-small">Nota Mínima: <span id="tag-nota-minima-${element.id}">${parseInt(element.nota_minima)}</span></span>
                            <span class="tag-peso-cadastrado uni-body-small">Peso cadastrado: <span id="tag-peso-cadastrado-${element.id}">${parseInt(element.peso_cadastrado)}</span></span>`
            }
            $('#aulas-' + idModulo).append(`
                <div id="aula-${element.id}" class="aula">
                    <div class="d-flex justify-content-between align-items-center aula-card" data-id="${element.id}">
                        <div class="d-flex align-items-center">
                            <span class="material-symbols-outlined icon-modulos handleAula"
                                  style="margin-left:14px;margin-right:10px;cursor:pointer">drag_indicator</span>
                            <span class="material-symbols-outlined icon-aula mr-2">${icon}</span>
                            <div class="d-flex flex-column justify-content-center align-items-start" style="user-select: text">
                                <div class="uni-body-medium text-black titulo-${tipo}" data-id="${element.id}">${element.nome}</div>
                                <input type="hidden" class="ch-${tipo}" value="${cargaHoraria}" data-id="${element.id}">
                                <input type="hidden" class="obrigatoria-${tipo}" value="${element.certificado}" data-id="${element.id}">
                                <input type="hidden" class="posicao-${tipo}" value="${element.posicao}" data-id="${element.id}">
                                <input type="hidden" class="id-modulo" value="${idModulo}" data-id="${element.id}">
                                <input type="hidden" class="nota-minima-${tipo}" value="${parseInt(element.nota_minima)}" data-id="${element.id}">
                                <input type="hidden" class="retentativas-${tipo}" value="${element.retentativas}" data-id="${element.id}">
                                <input type="hidden" class="tempo-limite-${tipo}" value="${element.tempo_limite}" data-id="${element.id}">
                                <input type="hidden" class="data-maxima-${tipo}" value="${element.data_maxima_formatada}" data-id="${element.id}">
                                <input type="hidden" class="questoes-aleatorias-${tipo}" value="${element.questoes_aleatorias}" data-id="${element.id}">
                                <input type="hidden" class="mostra-gabarito-${tipo}" value="${element.mostra_gabarito}" data-id="${element.id}">
                                <input type="hidden" class="obrigatoria-${tipo}" value="${element.certificado}" data-id="${element.id}">
                                <input type="hidden" class="peso-avaliacao" data-peso="100" data-id="${element.id}">
                                <input type="hidden" class="tipo" value="${tipo}" data-id="${element.id}">

                            </div>
                        </div>
                        <div class="d-flex align-items-center justify-content-center h-100 p-2">
                            ${pesoTags}
                            <span class="material-symbols-outlined icon-modulos editar-${tipo}" style="cursor: pointer" data-id="${element.id}" data-text="${idModulo}" data-toggle="modal" data-target="#editar-${tipo}-modal">edit</span>
                            <span class="material-symbols-outlined icon-modulos excluir-${tipo} cursor-pointer" style="cursor: pointer" data-id="${element.id}">delete</span>
                            <span class="material-symbols-outlined icon-modulos expandir-${tipo}" style="cursor: pointer" data-id="${element.id}">expand_more</span>
                        </div>
                    </div>
                    <div class="px-2 pb-2 aula-itens d-none flex-column" data-id="${element.id}">
                        <div class="div-select-content text-black">
                            <span id="listar-itens-${element.id}" class="uni-label-large selecao-conteudo selected" data-listing="item" data-aulaid="${element.id}">Conteúdo da aula</span>
                            <span id="listar-anexos-${element.id}" class="uni-label-large selecao-conteudo" data-listing="anexo" data-aulaid="${element.id}">Anexos</span>
                        </div>
                        <hr class="m-0">

                        <div id="options-itens-aula-${element.id}" class="d-flex flex-column my-3">
                            <span class="uni-body-medium mb-2 text-black">Adicionar</span>
                            <div class="d-flex">
                                <span class="adicionar-video d-flex align-items-center border-radius-separator uni-label-large tag-item mr-2" data-id="${element.id}" data-toggle="modal" data-target="#adicionar-video-modal">
                                    <span class="material-symbols-outlined icon-aula mr-2">movie</span>
                                    Vídeo
                                </span>
                                <span class="adicionar-audio d-flex align-items-center border-radius-separator uni-label-large tag-item mr-2" data-id="${element.id}" data-toggle="modal" data-target="#adicionar-audio-modal">
                                    <span class="material-symbols-outlined icon-aula mr-2">volume_up</span>
                                    Áudio
                                </span>
                                <span class="adicionar-texto d-flex align-items-center border-radius-separator uni-label-large tag-item mr-2" data-id="${element.id}" data-toggle="modal" data-target="#adicionar-texto-modal">
                                    <span class="material-symbols-outlined icon-aula mr-2">description</span>
                                    Texto
                                </span>
                                <span class="adicionar-pdf d-flex align-items-center border-radius-separator uni-label-large tag-item mr-2" data-id="${element.id}" data-toggle="modal" data-target="#pdf-modal">
                                    <span class="material-symbols-outlined icon-aula mr-2">picture_as_pdf</span>
                                    PDF
                                </span>
                                <span class="adicionar-verificacao d-flex align-items-center border-radius-separator uni-label-large tag-item mr-2" data-id="${element.id}" data-toggle="modal" data-target="#adicionar-verificacao-modal">
                                    <span class="material-symbols-outlined icon-aula mr-2">check</span>
                                    Avaliação de verificação
                                </span>
                            </div>
                        </div>
                        <div id="itens-${element.id}" class="d-flex flex-column w-100 h-100">

                        </div>
                        <div id="anexos-${element.id}" class="flex-column w-100 h-100" style="gap: 4px;">

                        </div>
                        <div
                            id="file-upload-anexo-${element.id}"
                            class="file-upload-anexo d-none"
                            onclick="document.getElementById('file-input-anexo-${element.id}').click();"
                            ondrop="dropHandlerAnexo(event, ${element.id});"
                            ondragover="dragOverHandlerAnexo(event);"
                            data-aulaid="${element.id}"
                        >
                            <span class="material-symbols-outlined text-blue mt-3" style="font-size: 46px">upload</span>
                            <input
                                type="hidden"
                                id="input-aula-id"
                                value="${element.id}"
                            />
                            <input
                                name="anexo"
                                type="file"
                                id="file-input-anexo-${element.id}"
                                onchange="selectHandlerAnexo(this, event, ${element.id});"
                                hidden
                                value=""
                            />
                            <label class="uni-body-large text-grey-1 mt-1 mb-0" id="fileLabel">Arraste o arquivo até aqui</label>
                            <span class="uni-body-medium text-grey-2">ou</span>
                            <div class="upload-btn mt-4">
                                <span class="material-symbols-outlined text-blue">computer</span> <span class="uni-label-large text-blue ml-1">Fazer upload do computador</span>
                            </div>
                            <span class="uni-body-small text-grey-2 mt-2">Tamanho máximo de ${response.data.maxSizeFile}</span>
                        </div>
                    </div>
                    <div class="px-2 avaliacao-itens d-none flex-column" data-id="${element.id}">
                        <div class="d-flex flex-column mb-3">
                            <span class="uni-body-medium mb-2 text-black">Adicionar</span>
                            <div class="d-flex">
                                <span class="adicionar-questao-objetiva d-flex align-items-center border-radius-separator uni-label-large tag-item mr-2" data-id="${element.id}" data-toggle="modal" data-target="#adicionar-questao-objetiva-modal">
                                    <span class="material-symbols-outlined icon-aula mr-2">check_circle</span>
                                    Objetiva
                                </span>
                            </div>
                        </div>
                        <div id="itens-avaliacao-${element.id}" class="d-flex flex-column w-100 h-100">

                        </div>
                    </div>
                </div>`).slideDown('slow');
        });
    }
}

//função para arrastar aulas. Ao dropar salva posições
window.dragAndDropAulas = (idModulo) =>{
    dragula([document.getElementById('aulas-'+idModulo)], {
        moves: function(el, container, handle) {
            return handle.className === 'material-symbols-outlined icon-modulos handleAula';
        },
        revertOnSpill: true
    }).on('drop', function(el, _) {
        mudarPosicaoAulas(idModulo);
    }.bind(this));
}

window.criarItens = (response, idAula) => {
    $('#options-itens-aula-'+idAula).slideDown('slow', function() {
        $(this).addClass('d-flex');
    });
    $(`#file-upload-anexo-${idAula}`).slideUp('slow', function() {
        $(this).removeClass('d-flex');
    });
    $('#anexos-'+ idAula).slideUp('slow', function() {
        $(this).removeClass('d-flex').empty();
    });
    $('#itens-'+ idAula).hide().empty();
    var itens = response.data.itens;
    if(itens.length > 0){
            $.each(itens, function(index, element){
            var iconItem = null;
            switch (element.tipo) {
                case 'V':
                    iconItem = 'movie';
                    break;
                case 'A':
                    iconItem = 'volume_up';
                    break;
                case 'T':
                    iconItem = 'description';
                    break;
                case 'P':
                    iconItem = 'picture_as_pdf';
                    break;
                case 'AV':
                    iconItem = 'check';
                    break;
            }

            var tipoItem = element.tipo === 'AV' ? 'verificacao' : 'item';

            $('#itens-'+idAula).append(`
                <div id="item-${element.id}" class="item">
                    <div class="d-flex justify-content-between align-items-center item-card" data-id="${element.id}">
                        <div class="d-flex align-items-center">
                            <span class="material-symbols-outlined icon-modulos handleItem"
                                  style="margin-left:14px;margin-right:10px;cursor:pointer">drag_indicator</span>
                            <span class="material-symbols-outlined icon-aula mr-2">${iconItem}</span>
                            <div class="d-flex flex-column justify-content-center align-items-start" style="user-select: text">
                                <div class="uni-body-medium text-black titulo-item" data-id="${element.id}">${element.titulo}</div>
                                <input type="hidden" class="posicao-${tipoItem}" value="${element.posicao}" data-id="${element.id}">
                                <input type="hidden" class="id-aula" value="${idAula}" data-id="${element.id}">
                                <div style="display: none !important;" class="conteudo-item" data-id="${element.id}">${element.conteudo}</div>
                                <input type="hidden" class="rep-segundo-plano-item" value="${element.reproducao_segundo_plano}" data-id="${element.id}">
                                <input type="hidden" class="tipo-item" value="${element.tipo}" data-id="${element.id}">
                            </div>
                        </div>
                        <div class="d-flex align-items-start justify-content-center h-100 p-2">
                            <span class="material-symbols-outlined icon-modulos editar-${tipoItem}" style="cursor: pointer" data-id="${element.id}" data-text="${idAula}" data-toggle="modal" data-target="#editar-item-modal">edit</span>
                            <span class="material-symbols-outlined icon-modulos excluir-item cursor-pointer" style="cursor: pointer" data-id="${element.id}">delete</span>
                        </div>
                    </div>
                </div>`);
        });
        $('#itens-'+ idAula).slideDown('slow', function() {
            $(this).addClass('d-flex');
        });
    }
}

window.criarAnexos = (response, idAula) => {
    $('#options-itens-aula-'+idAula).slideUp('slow', function() {
        $(this).removeClass('d-flex');
    });
    $(`#file-upload-anexo-${idAula}`).slideDown('slow', function() {
        $(this).addClass('d-flex');
    });
    $('#itens-'+ idAula).slideUp('slow', function() {
        $(this).removeClass('d-flex').empty();
    });
    $('#anexos-'+ idAula).empty().removeClass('d-flex');
    var anexos = response.data.anexos;
    if(anexos.length > 0){
            $.each(anexos, function(index, element){
            $('#anexos-'+idAula).append(`
                <div id="anexos-${element.id}" class="anexo">
                    <div class="d-flex justify-content-between align-items-center anexo-card" data-id="${element.id}">
                        <div class="d-flex align-items-center">
                            <span class="uni-label-large text-grey-2 index">${(index + 1)}</span>
                            <div class="d-flex flex-column justify-content-center align-items-start" style="user-select: text">
                                <div class="uni-body-medium text-grey-1 titulo-anexo" data-id="${element.id}">${element.filename}</div>
                                <input type="hidden" class="id-aula-anexo" value="${idAula}" data-id="${element.id}">
                            </div>
                        </div>
                        <div class="d-flex align-items-start justify-content-center h-100">
                            <div class="infos">
                                <span class="uni-body-medium text-grey-2">${element.icone}</span>
                            </div>
                            <div class="infos">
                                <span class="uni-body-medium text-grey-2">${element.tamanho}</span>
                            </div>
                            <div class="infos">
                                <span class="material-symbols-outlined icon-modulos excluir-anexo" style="cursor: pointer" data-id="${element.id}">delete</span>
                            </div>
                        </div>
                    </div>
                </div>`);
        });
        $('#anexos-'+ idAula).slideDown('slow', function() {
            $(this).addClass('d-flex').addClass('py-4');
        });
        uniModalClose();
    } else {
        $('#anexos-'+ idAula).removeClass('d-flex').removeClass('py-4');
        uniModalClose();
    }
}

//função para arrastar itens. Ao dropar salva posições
window.dragAndDropItens = (idAula) =>{
    dragula([document.getElementById('itens-'+idAula)], {
        moves: function(el, container, handle) {
            return handle.className === 'material-symbols-outlined icon-modulos handleItem';
        },
        revertOnSpill: true
    }).on('drop', function(el, _) {
        mudarPosicaoItens(idAula);
    }.bind(this));
}

window.criarQuestoes = (response, idAvaliacao) => {
    $('#itens-avaliacao-'+ idAvaliacao).hide().empty();
    var itens = response.data.itens;
    if(itens.length > 0){
        $.each(itens, function(index, element){
            $('#itens-avaliacao-'+idAvaliacao).append(`
                <div id="item-avaliacao-${element.id}" class="item">
                    <div class="d-flex justify-content-between align-items-center item-avaliacao-card" data-id="${element.id}">
                        <div class="d-flex align-items-center">
                            <span class="material-symbols-outlined icon-modulos handleQuestao"
                                  style="margin-left:14px;margin-right:10px;cursor:pointer">drag_indicator</span>
                            <span class="material-symbols-outlined icon-aula mr-2">check_circle</span>
                            <div class="d-flex flex-column justify-content-center align-items-start" style="user-select: text">
                                <div class="uni-body-medium text-black enunciado-questao" data-id="${element.id}">${element.enunciado}</div>
                                <input type="hidden" class="id-avaliacao" value="${idAvaliacao}" data-id="${element.id}">
                                <input type="hidden" class="peso-questao" value="${element.peso}" data-id="${element.id}">
                                <input type="hidden" class="aleatoria-questao" value="${element.alternativas_aleatorias}" data-id="${element.id}">
                                <input type="hidden" class="alternativas-questao" value="${element.alternativas}" data-id="${element.id}">
                                <input type="hidden" class="respostas-questao" value="${element.respostas}" data-id="${element.id}">
                            </div>
                        </div>
                        <div class="d-flex align-items-center justify-content-center h-100 p-2">
                            <span class="uni-body-small tag-peso">Peso: ${element.peso}</span>
                            <span class="material-symbols-outlined icon-modulos editar-questao-avaliacao" style="cursor: pointer" data-id="${element.id}" data-text="${idAvaliacao}" data-toggle="modal" data-target="#adicionar-questao-objetiva-modal">edit</span>
                            <span class="material-symbols-outlined icon-modulos excluir-item-avaliacao cursor-pointer" style="cursor: pointer" data-id="${element.id}">delete</span>
                        </div>
                    </div>
                </div>`);
        });
        $('#itens-avaliacao-'+ idAvaliacao).slideDown('slow');
    }
}

//função para arrastar itens. Ao dropar salva posições
window.dragAndDropQuestoes = (idAvaliacao) =>{
    dragula([document.getElementById('itens-avaliacao-'+idAvaliacao)], {
        moves: function(el, container, handle) {
            return handle.className === 'material-symbols-outlined icon-modulos handleQuestao';
        },
        revertOnSpill: true
    }).on('drop', function(el, _) {
        mudarPosicaoQuestoes(idAvaliacao);
    }.bind(this));
}

window.formatFileSize = (bytes) => {
    const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    let unitIndex = 0;

    while (bytes >= 1024 && unitIndex < units.length - 1) {
      bytes /= 1024;
      unitIndex++;
    }

    return `${bytes.toFixed(1).replace('.', ',')} ${units[unitIndex]}`;
  }
